import styled from 'styled-components';
import "@fontsource/roboto-flex";
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const Wrapper = styled('div')({
    backgroundColor: "#E2D3BA",
    padding: "32px 60px 32px 60px",
    fontFamily: "Roboto Flex",

    [MediaQuery[Size.MD]]: {
        padding: "16px 30px 16px 30px",
    },
})

export const RowFlex1 = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',

    [MediaQuery[Size.MD]]: {
        flexDirection: 'column',
    },
})


export const FirstRowBox = styled('div')({
    width: "44%",
    [MediaQuery[Size.MD]]: {
        width: "100%"
    },
})

export const SecondRowBox = styled('div')({
    width: "44%",
    marginLeft: "4%",
    [MediaQuery[Size.MD]]: {
        width: "100%",
        marginLeft: "0%",
    },
})

export const RowFlex2 = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',

    [MediaQuery[Size.MD]]: {
        flexDirection: 'column',
    },
})

export const ThirdRowBox = styled('div')({
    width: "44%",
    marginLeft: "4%",
    textDecoration: "underline",
    [MediaQuery[Size.MD]]: {
        marginTop: "20px",
        width: "100%",
        
    },
    [MediaQuery[Size.LG]]: {
        marginLeft: "0%",
    },
})

export const FourthRowBox = styled('div')({
    width: "44%",
    marginLeft: "4%",
    color: "#CCA25E",
    fontWeight: "400",
    textDecoration: "underline",
    '& div': {
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    [MediaQuery[Size.MD]]: {
        width: "100%",
        marginLeft: "0%",
        marginTop: '12px'
    },
})

export const FourthRowBoxItem = styled('div')({
    cursor: 'pointer',
    textDecoration: 'underline',
})

export const WrapperFirstRow = styled('div')({
    display: 'Flex',
    flexDirection: 'row',

    [MediaQuery[Size.LG]]: {
        flexDirection: 'column',
    },    
})

export const Line = styled('hr')({
    borderTop : '1px solid black',
    marginTop: "20px",
    marginBottom: "20px"
})